import { Button, Flex } from "antd";
import useWepapp from "../hook/useWepapp";
import { useMediaQuery } from "react-responsive";

const { Outlet } = require("react-router-dom");

const ConsentComponent = ({
    p6 = "",
    Header = "",
    preconsent = () => { },
    consent1 = () => { },
    consent2 = () => { },
    consent3 = () => { },
    consent4 = () => { },
    checkboxFooter = () => { },
}) => {
    const { goToMenu = () => { } } = useWepapp();
    const isPortrait = useMediaQuery({ orientation: 'portrait' });

    return (
        <Flex vertical style={{ display: "flex", flexDirection: "column", height: "100vh", backgroundColor: "#FCF9F6" }}>
            <Flex vertical style={{ padding: isPortrait ? "5vh" : "8vw", width: "100%", flexGrow: 1, rowGap: "4vh", overflow: "hidden" }}>
                <Flex vertical>
                    <span style={{ color: "#646464" }}>{p6}</span>
                    <span style={{ color: "#2A2929", fontWeight: "bold", textAlign: "center" }}>{Header}</span>
                </Flex>

                <Flex vertical style={{ flexGrow: 1, gap: isPortrait ? "2vh" : "3vw", overflowY: "auto", scrollbarWidth: "none", }}>
                    {preconsent()}
                    {consent1()}
                    {consent2()}
                    {consent3()}
                    {consent4()}
                </Flex>
            </Flex>
            <Flex style={{ width: "100%", backgroundColor: "#FCF9F6" }}>
                {checkboxFooter()}
            </Flex>
        </Flex>
    );
};

export default ConsentComponent;
